import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const FolderStateForm_Folder_ActionPermissions_QueryDocument = graphql(`
  query FolderStateForm_Folder_ActionPermissions_Query($id: Id!) {
    findOneFolder(id: $id) {
      access {
        actions {
          ...FolderBusinessEntityStateForm_ActionPermission_Fragment
        }
      }
    }
  }
`);

export type FolderStateForm_Folder_ActionPermissions = ResultOf<
  typeof FolderStateForm_Folder_ActionPermissions_QueryDocument
>['findOneFolder'];

export const useFindAllFolderActionPermissionsQuery = (
  id = EMPTY_ID,
  enabled = !!id,
) =>
  useGraphQLQuery(
    FolderStateForm_Folder_ActionPermissions_QueryDocument,
    { id },
    { enabled: !!id && enabled },
  );
